import React from 'react';
import { ReissueDiscountAlert } from './ReissueDiscountAlert';

export const ReissueDiscountAlertContainer: React.FC = () => {
  return <ReissueDiscountAlert />;
};
